import React, { useEffect } from 'react';
import { useSchoolTransactions } from '../../DataStore/FeesTransactionContext';
import functions from '../../util/functions';
import CardTileA from '../Common/CardTileA';
import { numberFormat } from '../../util/araknerdlib';
import DashCardHeader from '../Dashboard/DashCardHeader';

const MetricRow = ({ title, value, icon, colorClass, isLast }) => (
    <div className={`d-flex align-items-center py-3 ${!isLast ? 'border-bottom border-light' : ''}`}>
        {/* Icon: Using a circle with a VERY soft tint background */}
        <div className={`rounded-circle bg-soft-${colorClass} text-${colorClass} d-flex align-items-center justify-content-center shadow-none`} 
             style={{ 
                 width: '44px', 
                 height: '44px', 
                 minWidth: '44px',
                 backgroundColor: `var(--bg-soft-${colorClass})` // Use the opacity-based colors
             }}>
            <i className={`fa ${icon}`} style={{ fontSize: '1.2rem' }}></i>
        </div>

        {/* Text Content */}
        <div className="ms-3 flex-grow-1">
            <span className="text-uppercase text-muted fw-bold mb-0" style={{ fontSize: '10px', letterSpacing: '0.05rem', display: 'block' }}>
                {title}
            </span>
            <div className="d-flex align-items-center mt-1">
                <span className="text-muted fw-normal me-1" style={{ fontSize: '11px' }}>UGX</span>
                <h5 className="fw-extrabold mb-0" style={{ color: '#1e293b', fontSize: '1.25rem', letterSpacing: '-0.5px' }}>
                    {value}
                </h5>
            </div>
        </div>

        {/* Subtle Interactive Hint */}
        <div className="text-light ms-2">
            <i className="fa fa-chevron-right" style={{ fontSize: '12px', opacity: 0.3 }}></i>
        </div>
    </div>
);

const FeesMetricCards = ({currency}) => {
    const { paidSum, billedSum, discountedSum, getBilledSum, getPaidSum, getDiscountedSum } = useSchoolTransactions();
    
    useEffect(() => {
        getBilledSum(); getPaidSum(); getDiscountedSum();
    }, []);

    return (
        <DashCardHeader title="Financial Summary" description="Fees expected this term - Accounts Receivable." iconClass="fa fa-calculator">
         
                
                    <CardTileA 
                        title="Termly Billed" 
                        value={billedSum ? numberFormat(billedSum) : '--'}
                        cardIcon="fa fa-file-invoice-dollar"
                        cardIconClass="text-primary"
                        preText={`This term (${currency || ''}) - Includes invoices of deactivated students (if any)`}
                        borderColorClass={'primary'}
                    />
                     <CardTileA 
                        title="Termly Paid" 
                        value={paidSum ? numberFormat(paidSum) : '--'}
                        cardIcon="fa fa-hand-holding-usd"
                        cardIconClass="text-success"
                        preText={`This term (${currency || ''})  - Actual revenue without discounts. Includes fees advances.`}
                        borderColorClass={'success'}
                        className="mt-4"
                    />
                

              
            </DashCardHeader>
    );
};

export default FeesMetricCards;